import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import CustomerEngagement from "./assets/img/CustomerEngagement.png";
import WebsiteDevelopment from "./assets/img/WebsiteDevelopment.png";
import WorkflowAutomation from "./assets/img/WorkflowAutomation.png";
import SearchEngineOptimization from "./assets/img/SearchEngineOptimization.png";
import SocialMediaManagement from "./assets/img/SocialMediaManagement.png";
import CMS from "./assets/img/CMS.png";
import caseStudyIco1 from "./assets/img/caseStudyIco-1.png";
const DigitalTransformation = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const initialSection = splitLocation[1] || "aiPowered";

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="innerPageIntroData aipageDataWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-5 sticyDiv padRightWrap">
                <div className="sticyDiv">
                  <div className="titleWrap">
                    <h2>Digital Transformation</h2>
                    <p>
                      Accelerate Your Journey to Digital Excellence with
                      Hummingtec Solutions
                    </p>
                  </div>
                  <div className="dataWrap">
                    <p>
                      In an era where technology evolves at lightning speed,
                      staying ahead means embracing change. At Hummingtec
                      Solutions, we specialize in guiding businesses through the
                      complex landscape of digital transformation. Our
                      comprehensive services are designed to streamline
                      processes, enhance operational efficiency, and unlock new
                      opportunities for growth and innovation.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <ul className="aiMlList">
                  <li>
                    <div className="itemWrap clr1">
                      <Link to="/websiteDevelopment">
                        <div className="imgWrap">
                          <img
                            src={WebsiteDevelopment}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Website Development</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr2">
                      <Link to="/CustomApplication">
                        <div className="imgWrap">
                          <img
                            src={SearchEngineOptimization}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Custom Application Development</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr3">
                      <Link to="/MobileApplication">
                        <div className="imgWrap">
                          <img
                            src={SocialMediaManagement}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Mobile Application Development</h2>
                        </div>
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap clr4">
                      <Link to="/ProcessDiscovery">
                        <div className="imgWrap">
                          <img
                            src={CustomerEngagement}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Process Discovery & Digital Blueprinting</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr5">
                      <Link to="/DataMigration">
                        <div className="imgWrap">
                          <img src={CMS} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Data Migration & Task Automation</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr6">
                      <Link to="/WorkflowAutomation">
                        <div className="imgWrap">
                          <img
                            src={WorkflowAutomation}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Workflow Automation</h2>
                        </div>
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap clr1">
                      <Link to="/RealTimeDashboards">
                        <div className="imgWrap">
                          <img
                            src={WebsiteDevelopment}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Real-Time Dashboards & Reporting</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr2">
                      <Link to="/AIPoweredForecasting">
                        <div className="imgWrap">
                          <img
                            src={SearchEngineOptimization}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>AI-Powered Forecasting</h2>
                        </div>
                      </Link>
                    </div>
                    <div className="itemWrap clr3">
                      <Link to="/CloudAccessibility">
                        <div className="imgWrap">
                          <img
                            src={SearchEngineOptimization}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="dataWrap">
                          <h2>Cloud Accessibility</h2>
                        </div>
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugBenefitsWrap benefitsDigiWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Why Partner with Hummingtec Solutions?</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#6cdc99"
                                  opacity="1"
                                  data-original="#6cdc99"
                                ></path>
                              </clipPath>
                            </defs>
                            <g
                              clip-path="url(#a)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0h-312.839v-492H74.142v407.853z"
                                transform="translate(375.349 502)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                              ></path>
                              <path
                                d="M0 0h74.142L0 84.147Z"
                                transform="translate(375.349 417.853)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                              ></path>
                              <path
                                d="M0 0c-30.038 17.947-50.151 50.785-50.151 88.314 0 56.78 46.029 102.81 102.809 102.81 56.78 0 102.81-46.03 102.81-102.81 0-12.596-2.266-24.665-6.412-35.818"
                                transform="translate(203.342 269.815)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0c0-23.597-19.129-42.725-42.726-42.725-23.596 0-42.725 19.128-42.725 42.725 0 23.596 19.129 42.725 42.725 42.725C-19.129 42.725 0 23.596 0 0Z"
                                transform="translate(298.726 380.647)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0v-51.336c-15.404-9.208-33.416-14.496-52.658-14.496-19.242 0-37.254 5.288-52.658 14.496V0c0 9.263 7.5 16.772 16.763 16.772h71.789C-7.501 16.772 0 9.263 0 0Z"
                                transform="translate(308.658 321.15)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0 12.105-19.763 22.536-5.405-15.055-17.62 1.823-23.104L0-57.019l-21.41-8.873 1.823 23.104-15.054 17.62 22.536 5.405z"
                                transform="translate(153.005 217.922)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0 12.105-19.763 22.536-5.405-15.054-17.62 1.822-23.104L0-57.019l-21.409-8.873 1.823 23.104-15.055 17.62 22.536 5.405z"
                                transform="translate(256 217.922)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0 12.104-19.763 22.537-5.405-15.055-17.62 1.823-23.104L0-57.019l-21.41-8.873 1.823 23.104-15.055 17.62 22.537 5.405z"
                                transform="translate(358.995 217.922)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0v0"
                                transform="translate(347.497 110)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h144.156"
                                transform="translate(164.502 110)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h275.271"
                                transform="translate(118.364 65.203)"
                                fill="none"
                                stroke="#6cdc99"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#6cdc99"
                                opacity="0.45"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Expertise and Experience</h2>
                        <p>
                          Our team of digital transformation experts brings a
                          wealth of knowledge and hands-on experience across
                          various industries.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M28.5 24H1c-.6 0-1-.5-1-1v-6.4c0-2.8 2.3-5.2 5.2-5.2h26.7c.6 0 1 .5 1 1s-.5 1-1 1H5.1c-1.7 0-3.1 1.4-3.1 3.1v5.4h26.5c.6 0 1 .5 1 1s-.4 1.1-1 1.1z"
                              fill="#67a9d5"
                              opacity="1"
                              data-original="#67a9d5"
                            ></path>
                            <path
                              d="M5.1 61c-1.4 0-2.7-.5-3.6-1.5-1-1-1.5-2.3-1.5-3.7V22.9c0-.6.5-1 1-1h27.5c.6 0 1 .5 1 1s-.5 1-1 1H2v31.8c0 .8.3 1.6.9 2.2s1.4.9 2.2.9H52c1.7 0 3.1-1.4 3.1-3.1v-20c0-.6.5-1 1-1s1 .5 1 1v20c0 2.8-2.3 5.2-5.2 5.2H5.1zM9 18.7H6.8c-.6 0-1-.5-1-1s.5-1 1-1H9c.6 0 1 .5 1 1s-.4 1-1 1zM13.9 18.7h-2.2c-.6 0-1-.5-1-1s.5-1 1-1h2.2c.6 0 1 .5 1 1s-.4 1-1 1zM18.8 18.7h-2.2c-.6 0-1-.5-1-1s.5-1 1-1h2.2c.6 0 1 .5 1 1s-.4 1-1 1z"
                              fill="#67a9d5"
                              opacity="1"
                              data-original="#67a9d5"
                            ></path>
                            <path
                              d="M24.6 42.1H10c-1.7 0-3.1-1.4-3.1-3.1v-8.7c0-1.7 1.4-3.1 3.1-3.1h14.6c1.7 0 3.1 1.4 3.1 3.1V39c0 1.7-1.4 3.1-3.1 3.1zm0-12.9H10c-.6 0-1 .5-1 1V39c0 .6.5 1 1 1h14.6c.6 0 1-.5 1-1v-8.7c0-.6-.5-1.1-1-1.1zM35.1 35.9H34c-.6 0-1-.5-1-1s.5-1 1-1h1.1c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 42.5H34c-.6 0-1-.5-1-1s.5-1 1-1h15.8c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 49.1H7.4c-.6 0-1-.5-1-1s.5-1 1-1h42.4c.6 0 1 .5 1 1s-.5 1-1 1zM49.8 55.7H7.4c-.6 0-1-.5-1-1s.5-1 1-1h42.4c.6 0 1 .5 1 1s-.5 1-1 1zM48.4 36.3h-1.6c-1.3 0-2.4-1-2.6-2.2l-.4-2.5c0-.2-.2-.3-.3-.4-.4-.1-.7-.3-1.1-.4-.2-.1-.3-.1-.5 0l-2 1.5c-1 .7-2.5.6-3.4-.3l-1.2-1.2c-.9-.9-1-2.3-.3-3.4l1.5-2c.1-.2.1-.4 0-.5-.2-.3-.3-.7-.5-1.1-.1-.2-.2-.3-.4-.3l-2.4-.4c-1.3-.2-2.2-1.3-2.2-2.6v-1.7c0-1.3.9-2.4 2.2-2.6l2.4-.4c.2 0 .3-.2.4-.3.1-.4.3-.7.5-1.1.1-.2.1-.4 0-.5l-1.5-2c-.8-1-.6-2.4.2-3.4l1.2-1.2c.9-.9 2.4-1 3.4-.2l1.9 1.5c.2.2.4.1.5 0 .4-.2.7-.3 1.1-.5.2-.1.3-.2.4-.4l.4-2.5C44.4 4 45.5 3 46.8 3h1.6c1.3 0 2.4 1 2.6 2.2l.4 2.5c0 .2.2.3.3.4.4.1.7.3 1.1.4.2.1.3.1.5 0l2-1.5c1-.8 2.5-.6 3.4.3l1.2 1.2c.9.9 1 2.3.3 3.4l-1.5 2c-.1.2-.1.4 0 .5.2.3.3.7.5 1.1.1.2.2.3.4.3l2.4.4c1.3.2 2.2 1.3 2.2 2.6v1.7c0 1.3-.9 2.4-2.2 2.6l-2.4.4c-.2 0-.3.2-.4.3-.1.4-.3.7-.4 1.1-.1.2-.1.4 0 .6l1.5 2c.7 1 .6 2.4-.2 3.4L58.6 32c-.9.9-2.4 1-3.4.2l-1.9-1.5c-.2-.2-.4-.1-.5 0-.4.2-.7.3-1.1.5-.2.1-.3.2-.3.4l-.4 2.5c-.2 1.2-1.3 2.2-2.6 2.2zm-6.3-7.7c.4 0 .8.1 1.1.3.3.1.6.3.9.4.9.3 1.5 1.1 1.7 2l.4 2.5c0 .3.3.5.5.5h1.6c.3 0 .5-.2.5-.4l.4-2.5c.1-.9.8-1.7 1.7-2 .3-.1.6-.2.9-.4.8-.4 1.9-.3 2.7.3l2 1.5c.3.2.5.1.7-.1l1.2-1.2c.2-.2.2-.5 0-.7l-1.5-2c-.6-.8-.7-1.8-.3-2.6.1-.3.3-.6.4-.9.3-.9 1.1-1.6 2-1.7l2.4-.4c.3 0 .4-.3.4-.5V19c0-.3-.2-.5-.4-.5l-2.4-.4c-.9-.1-1.7-.8-2-1.7-.1-.3-.2-.6-.4-.9-.4-.9-.3-1.9.2-2.7l1.5-2c.2-.2.1-.5 0-.7l-1.2-1.2c-.1-.1-.3-.2-.4-.2s-.2 0-.3.1l-1.9 1.5c-.7.6-1.8.7-2.7.3-.3-.1-.6-.3-.9-.4-.9-.3-1.5-1.1-1.7-2l-.4-2.5c0-.3-.3-.5-.5-.5h-1.6c-.3 0-.5.2-.5.4L45.9 8c-.1.9-.8 1.7-1.7 2-.3.1-.6.2-.9.4-.8.4-1.9.3-2.7-.3l-2-1.5c-.3-.3-.5-.1-.7.1l-1.2 1.2c-.2.2-.2.5 0 .7l1.5 2c.5.8.6 1.8.2 2.6-.1.3-.3.6-.4.9-.3.9-1.1 1.6-2 1.7l-2.4.4c-.3 0-.4.3-.4.5v1.7c0 .3.2.5.4.5l2.4.4c.9.1 1.7.8 2 1.7.1.3.2.6.4.9.4.9.3 1.9-.3 2.7l-1.5 2c-.2.2-.1.5 0 .7l1.2 1.2c.2.2.4.3.7.1l2-1.5c.5-.3 1.1-.5 1.6-.5z"
                              fill="#67a9d5"
                              opacity="0.45"
                              data-original="#67a9d5"
                            ></path>
                            <path
                              d="M47.6 26.3a6.7 6.7 0 1 1 0-13.4 6.7 6.7 0 0 1 0 13.4zm0-11.3C45 15 43 17.1 43 19.6c0 2.6 2.1 4.6 4.6 4.6s4.6-2.1 4.6-4.6-2.1-4.6-4.6-4.6z"
                              fill="#67a9d5"
                              opacity="1"
                              data-original="#67a9d5"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Customized Solutions</h2>
                        <p>
                          We understand that one size does not fit all. Our
                          approach is to tailor solutions that specifically
                          address your unique challenges and opportunities.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="m61.12 38.24-1.941-.48a28 28 0 1 0-54.358 0l-1.941.48a30 30 0 1 1 58.24 0z"
                              fill="#cb9cee"
                              opacity="0.45"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M14.027 35.008a1.04 1.04 0 0 1-.651-.227 5.7 5.7 0 0 1-1.619-3.427 1.489 1.489 0 0 1 .747-1.222c.769-.439 2.261-.4 4.742-.19.3.027.546.05.69.056a4.624 4.624 0 0 0 2.108-2.292c.614-2 3.1-4.518 5.546-5.618A8.928 8.928 0 0 1 29.774 21c.819-.825 2.051-4.523 1.413-5.418-.411-.574-1.925-1.16-3.143-1.631-1.882-.728-3.507-1.357-3.979-2.594s.017-3.9.656-6.98c.133-.645.259-1.253.285-1.486a1 1 0 1 1 1.988.22c-.036.328-.153.891-.315 1.671-.287 1.385-1.049 5.064-.744 5.863.181.416 1.905 1.083 2.831 1.441 1.692.654 3.29 1.272 4.047 2.334 1.235 1.727.056 5.108-.74 6.655C31.4 22.388 30.738 23 30 23h-.194a6.823 6.823 0 0 0-3.4.913 9.083 9.083 0 0 0-4.454 4.382C21.391 30.133 19.178 32 18 32c-.156 0-.492-.026-.928-.064a23.945 23.945 0 0 0-3.251-.126 5.636 5.636 0 0 0 .848 1.448.974.974 0 0 1 .135 1.386.989.989 0 0 1-.777.364zM6 36.727a.989.989 0 0 1-.227-.026 7.083 7.083 0 0 1-2.163-.773 1.031 1.031 0 0 1-.477-1.358.974.974 0 0 1 1.312-.47c.049.025.1.054.164.09a5.277 5.277 0 0 0 1.617.558A1 1 0 0 1 6 36.727zM45.78 25.058a3.569 3.569 0 0 1-1.474-.412C43.765 24.389 42 23.438 42 22c0-.348.01-.8.021-1.281.019-.84.044-1.968 0-2.479l-.048-.035A2.307 2.307 0 0 1 41 15.932l.031-.457.369-.275c.183-.137 4.544-3.345 9.047-1.095l.1.057a6.258 6.258 0 0 1 1.519 2.055c.261.445.531.905.74 1.189a1.266 1.266 0 0 1 .2 1.086c-.255.944-1.492 1.611-4.352 2.841-.43.185-.966.415-1.091.492l-.059.036a3.731 3.731 0 0 0-.249 1.2 2.341 2.341 0 0 1-.625 1.712 1.3 1.3 0 0 1-.85.285zM43.057 16.5a1 1 0 0 0 .132.113 1.828 1.828 0 0 1 .8 1.247 24.719 24.719 0 0 1 .03 2.9c-.011.464-.021.9-.021 1.235a3.277 3.277 0 0 0 1.263.89v-.038c.1-.9.227-2.134 1.207-2.7a11.175 11.175 0 0 1 1.39-.652 25.48 25.48 0 0 0 2.973-1.436c-.161-.258-.327-.541-.5-.834a11.809 11.809 0 0 0-.883-1.379c-2.648-1.261-5.348.033-6.391.654zm4.436 5.365-.016.01zM32 47a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM43 61a1 1 0 0 1-1-1v-7a3 3 0 0 0-3-3H25a3 3 0 0 0-3 3v7a1 1 0 0 1-2 0v-7a5.006 5.006 0 0 1 5-5h14a5.006 5.006 0 0 1 5 5v7a1 1 0 0 1-1 1zM12 52a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM1 61a1 1 0 0 1-1-1v-2a5.006 5.006 0 0 1 5-5h13a1 1 0 0 1 0 2H5a3 3 0 0 0-3 3v2a1 1 0 0 1-1 1zM52 52a7.009 7.009 0 0 1-7-7v-2a7 7 0 0 1 14 0v2a7.009 7.009 0 0 1-7 7zm0-14a5.006 5.006 0 0 0-5 5v2a5 5 0 0 0 10 0v-2a5.006 5.006 0 0 0-5-5zM63 61a1 1 0 0 1-1-1v-2a3 3 0 0 0-3-3H46a1 1 0 0 1 0-2h13a5.006 5.006 0 0 1 5 5v2a1 1 0 0 1-1 1z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Collaborative Partnership</h2>
                        <p>
                          We work as an extension of your team, ensuring
                          seamless communication and alignment with your
                          business objectives.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M51.464 41.328A9.234 9.234 0 0 0 48.88 41a9.57 9.57 0 0 0-2.345.331 1 1 0 0 0-.742.967l-.007.998a7.643 7.643 0 0 0-1.131.63.133.133 0 0 1-.1-.016l-.863-.482a1.001 1.001 0 0 0-1.177.148 8.936 8.936 0 0 0-2.482 4.162 1 1 0 0 0 .479 1.131l.9.503a6.813 6.813 0 0 0 0 1.256l-.9.503a1 1 0 0 0-.479 1.13 8.927 8.927 0 0 0 2.477 4.165 1.001 1.001 0 0 0 1.177.149l.868-.485a.139.139 0 0 1 .098-.018 12.114 12.114 0 0 0 1.14.666v.968a1 1 0 0 0 .742.966 9.563 9.563 0 0 0 2.47.328h.113a9.57 9.57 0 0 0 2.345-.331 1 1 0 0 0 .742-.967l.007-.998a7.643 7.643 0 0 0 1.131-.63.133.133 0 0 1 .1.016l.863.483a.998.998 0 0 0 1.177-.15 8.937 8.937 0 0 0 2.482-4.16 1 1 0 0 0-.479-1.132l-.9-.503a6.813 6.813 0 0 0 0-1.256l.9-.503a1 1 0 0 0 .479-1.131 8.933 8.933 0 0 0-2.477-4.164 1.001 1.001 0 0 0-1.177-.149l-.868.485a.148.148 0 0 1-.098.018 12.149 12.149 0 0 0-1.14-.666v-.968a1 1 0 0 0-.742-.966Zm.763 4.257a2.115 2.115 0 0 0 2.192.071l.19-.106a6.923 6.923 0 0 1 1.185 1.974l-.78.435a1 1 0 0 0-.494 1.06 4.968 4.968 0 0 1 0 1.961 1 1 0 0 0 .495 1.06l.779.436a6.937 6.937 0 0 1-1.188 1.972l-.188-.105a2.107 2.107 0 0 0-2.191.072 5.642 5.642 0 0 1-.836.465 2.034 2.034 0 0 0-1.185 1.858v.16a7.186 7.186 0 0 1-1.112.101 7.11 7.11 0 0 1-1.3-.1v-.161a2.034 2.034 0 0 0-1.185-1.858 5.65 5.65 0 0 1-.836-.466 2.111 2.111 0 0 0-2.192-.07l-.19.106a6.919 6.919 0 0 1-1.185-1.974l.78-.436a1 1 0 0 0 .494-1.06 4.968 4.968 0 0 1 0-1.96 1 1 0 0 0-.495-1.06l-.779-.436a6.937 6.937 0 0 1 1.189-1.972l.187.104a2.111 2.111 0 0 0 2.191-.071 5.642 5.642 0 0 1 .836-.465 2.034 2.034 0 0 0 1.185-1.858v-.16a7.186 7.186 0 0 1 1.112-.101 7.559 7.559 0 0 1 1.3.1v.161a2.034 2.034 0 0 0 1.185 1.858 5.601 5.601 0 0 1 .836.465Z"
                              fill="#e2e283"
                              opacity="1"
                              data-original="#e2e283"
                            ></path>
                            <path
                              d="M45 50a4 4 0 1 0 4-4 4.005 4.005 0 0 0-4 4Zm6 0a2 2 0 1 1-2-2 2.002 2.002 0 0 1 2 2ZM2 6v51a2.002 2.002 0 0 0 2 2h32v-2H4V6h14v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6h14v29h2V6a2.002 2.002 0 0 0-2-2H34a3.003 3.003 0 0 0-3-3H21a3.003 3.003 0 0 0-3 3H4a2.002 2.002 0 0 0-2 2Zm18-2a1.001 1.001 0 0 1 1-1h10a1.001 1.001 0 0 1 1 1v3H20Z"
                              fill="#e2e283"
                              opacity="1"
                              data-original="#e2e283"
                            ></path>
                            <path
                              d="M15 46a1 1 0 0 0 1-1V26a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1Zm-4-19h3v17h-3ZM24 46a1 1 0 0 0 1-1V23a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1Zm-4-22h3v20h-3ZM33 46a1 1 0 0 0 1-1V28a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1Zm-4-17h3v15h-3ZM43 38V23a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v19h2V24h3v14Z"
                              fill="#e2e283"
                              opacity="0.45"
                              data-original="#e2e283"
                            ></path>
                            <path
                              d="m43.553 13.105-13.499 6.75-7.524-4.703a1.002 1.002 0 0 0-.881-.088l-16 6 .702 1.872L21.89 17.11l7.581 4.738a1.005 1.005 0 0 0 .977.047l14-7ZM6 48h29v2H6zM62 50q0-.547-.044-1.083l-1.994.165Q60 49.537 60 50q0 .464-.038.917l1.994.165Q62 50.548 62 50ZM49 37a12.993 12.993 0 0 0-12.59 9.75l1.936.5a11.004 11.004 0 0 1 21.308 0l1.936-.5A12.993 12.993 0 0 0 49 37ZM38.038 50.917Q38 50.463 38 50q0-.464.038-.917l-1.994-.165Q36 49.452 36 50q0 .547.044 1.083ZM49 63a12.993 12.993 0 0 0 12.59-9.75l-1.936-.5a11.004 11.004 0 0 1-21.308 0l-1.936.5A12.993 12.993 0 0 0 49 63Z"
                              fill="#e2e283"
                              opacity="0.45"
                              data-original="#e2e283"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Outcome-Focused</h2>
                        <p>
                          Your success is our success. We're committed to
                          delivering measurable results that impact your bottom
                          line.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Transform Your Business with Hummingtec Solutions</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    Embrace the digital future confidently with Hummingtec
                    Solutions. Our digital transformation services are your
                    gateway to becoming a more agile, efficient, and innovative
                    organization. Ready to embark on a transformative journey?
                    Contact us today to explore how we can elevate your business
                    in the digital age.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default DigitalTransformation;
